<template>
	<div class="page_warp">
		<!-- <div class="top_content" style="display: table;justify-content: space-between; margin-bottom: 10px">
			<div class="nav_warp">
				<div class="nav_item" :class="index == 0 ? 'nav_item_ac' : ''" @click="navClick(0)">
					<span>车务管理(0)</span>
					<div v-if="index == 0" class="nav_item_line"></div>
				</div>
				<div class="nav_item" :class="index == 1 ? 'nav_item_ac' : ''" @click="navClick(1)">
					<span>系统公告(0)</span>
					<div v-if="index == 1" class="nav_item_line"></div>
				</div>
			</div>
		</div>
		<div class="bottom_content2">
			<div v-show="index==0">
				<div class="messageBottomLeft">
					<div class="messageLeftList">
						<span class="messageLeftName">全部</span>
					</div>
					<div class="messageLeftList">
						<span class="messageLeftName">全部</span>
					</div>
					<div class="messageLeftList">
						<span class="messageLeftName">全部</span>
					</div>
					<div class="messageLeftList">
						<span class="messageLeftName">全部</span>
					</div>
				</div>
				<div class="emptyDiv">
				</div>
			</div>
			<div v-show="index==1">
			</div>
		</div> -->
		<div class="message">
			<div class="messageCen">
				<div class="messageT"> 消息中心 
					<div class="messageTRight"><span>弹框提醒</span>
						<el-switch v-model="alertValue" active-text="开启" inactive-text="关闭"></el-switch>
					</div>
				</div>
				<div class="messageDiv">
					<div class="messageTop">
						<div class="el-tabs el-tabs--top">
							<div class="el-tabs__header is-top">
								<div class="el-tabs__nav-wrap is-top">
									<div class="el-tabs__nav-scroll">
										<div role="tablist" class="el-tabs__nav is-top">
											<div class="el-tabs__active-bar is-top"
												:style="{width: '75px', transform: `translateX(${translateXValue}px)` }">
											</div>
											<!-- <div id="tab-13" aria-controls="pane-13" role="tab"
												:class="tabindex == 1 ? 'el-tabs__item is-top is-active' : ''"
												class="el-tabs__item is-top" @click="navClick(1)">车辆报警(0)</div>
											<div id="tab-11" aria-controls="pane-11" role="tab"
												:class="tabindex == 2 ? 'el-tabs__item is-top is-active' : ''"
												class="el-tabs__item is-top" @click="navClick(2)">设备服务(0)</div> -->
											<div id="tab-12" aria-controls="pane-12" role="tab"
												:class="tabindex == 1 ? 'el-tabs__item is-top is-active' : ''"
												class="el-tabs__item is-top" @click="navClick(1)">车务管理(0)
											</div>
											<!-- <div id="tab-15" aria-controls="pane-15" role="tab"
												:class="tabindex == 4 ? 'el-tabs__item is-top is-active' : ''"
												class="el-tabs__item is-top" @click="navClick(4)">设备异常(0)</div> -->
											<div id="tab-14" aria-controls="pane-14" role="tab"
												:class="tabindex == 2 ? 'el-tabs__item is-top is-active' : ''"
												class="el-tabs__item is-top" @click="navClick(2)">系统公告(0)</div>
										</div>
									</div>
								</div>
							</div>
						</div><button type="button"
							class="el-button readBtn el-button--text el-button--small"><!----><!----><span>全部已读</span></button>
					</div>
					<div class="messageBottom">
						<div class="messageBottomLeft">
							<div>
								<div class="messageLeftList" :class="Leftindex == 1 ? 'messageLeftList this' : ''"
									@click="leftClick(1)"><span class="messageLeftName">全部</span><span
										class="messageLeftNum"></span></div>
								<div class="messageLeftList" :class="Leftindex == 2 ? 'messageLeftList this' : ''"
									@click="leftClick(2)"><span class="messageLeftName">车辆保养</span><span
										class="messageLeftNum"></span></div>
								<div class="messageLeftList" :class="Leftindex == 3 ? 'messageLeftList this' : ''"
									@click="leftClick(3)"><span class="messageLeftName">轮胎更换</span><span
										class="messageLeftNum"></span></div>
								<div class="messageLeftList" :class="Leftindex == 4 ? 'messageLeftList this' : ''"
									@click="leftClick(4)"><span class="messageLeftName">车辆保险</span><span
										class="messageLeftNum"></span></div>
								<div class="messageLeftList" :class="Leftindex == 5 ? 'messageLeftList this' : ''"
									@click="leftClick(5)"><span class="messageLeftName">车辆年检</span><span
										class="messageLeftNum"></span></div>
								<div class="messageLeftList" :class="Leftindex == 6 ? 'messageLeftList this' : ''"
									@click="leftClick(6)"><span class="messageLeftName">油卡余额提醒</span><span
										class="messageLeftNum"></span></div>
							</div>
						</div>
						<div class="emptyDiv"><img src="@/assets/images/empty.png" alt="">
							<p>暂无数据</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<el-dialog title="审核" v-model="isAudit" width="30%" center>
			<div class="mar-bot-20"><span style="color: red">*</span>审核意见</div>
			<div style="width: 100%; height: 80px">
				<el-input type="textarea" v-model="auditsRemark" placeholder="请输入审核意见"></el-input>
			</div>
			<div class="btn_warp">
				<div class="btn-outline1" @click="Auditssubmit(1)">不通过</div>
				<div class="btn-outline2" @click="Auditssubmit(0)">通过</div>
			</div>
		</el-dialog>

		<Add ref="addRef" v-if="isAdd" @getData="getData" />
		<Edit ref="editRef" v-if="isEdit" @getData="getData" />
		<Detail ref="detailRef" v-if="isDetail" @getData="getData" />

	</div>
</template>

<script>
	import {
		computed,
		defineComponent,
		reactive,
		toRefs,
		nextTick,
		onMounted,
		getCurrentInstance,
	} from "vue";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import Add from "./components/add";
	import Edit from "./components/edit";
	import Detail from "./components/detail";
	export default defineComponent({
		components: {
			Add,
			Edit,
			Detail
		},
		name: "messageManage",
		setup() {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const data = reactive({
				tableId: "roleManagementTable",
				tabindex: 1,
				Leftindex: 1,
				translateXValue: 0,
				alertValue:true,
				index: 0,
				ChkStatus: "",
				EaStatus: "",
				checkType: "",
				AdvanceType: "",
				isAudit: false,
				auditsexoId: "",
				auditsRemark: "",
				page: 1,
				pageSize: 10,
				searchWord: "",
				totalCount: 0,
				tableData: [],
				tableHeight: 0,
				isAdd: false,
				isEdit: false,
				isDetail: false,
				sendData: null,
				changeLorstatus: "", //运单进度：空为全部 0待接单，1进行中，2已完成，3已关闭，10待审核
				orderNum: null,
				dayArr: [],
				exoSumCount: 0,
				exoSumMoney: 0,
				exoWaitPayMoney: 0,
				exoWaitChkMoney: 0,
			});
			onMounted(() => {
				console.log(store.state.userInfo);
				nextTick(() => {
					data.tableHeight =
						document.querySelector(
							".bottom_content2 .table_container#" + data.tableId
						).offsetHeight - 40;

					//data.dayArr = get24hoursRangeTime();
					getData();
				});
				window.onresize = () => {
					nextTick(() => {
						var offsetHeight = document.querySelector(
							".bottom_content2 .table_container#" + data.tableId
						).offsetHeight;
						if (offsetHeight <= 0) {
							return false;
						}
						data.tableHeight = document.querySelector(
							"bottom_content2 .table_container#" + data.tableId
						).offsetHeight;
					});
				};
			});
			//获取列表数据
			const getData = async () => {
				console.log(data.dayArr);
				let params = {
					searchWord: data.searchWord,
					page: data.page,
					limit: data.pageSize,
					exoType: data.checkType, //费用类型
					exoOdrId: "", //运单号
					exoAdvanceType: data.AdvanceType, //0公司固定点费用；1垫付
					exoChkStatus: data.ChkStatus, //审核状态：0未审核；1通过；2不通过
					exoEaStatus: data.EaStatus, //报销状态：0未报销；1已报销
					startTime: data.dayArr && data.dayArr.length > 0 ? data.dayArr[0] : "",
					endTime: data.dayArr && data.dayArr.length > 0 ? data.dayArr[1] : "",
				};
				const r = await proxy.$http.get(apiObj.expensesOrderList, params);
				console.log(r);
				if (r.code === 0) {
					getOrderListCount();

					data.tableData = r.rows;
					data.totalCount = r.total;

					getListSum(); //获取汇总统计数据
				}

			};

			//获取汇总统计数据
			const getListSum = async () => {

				let params = {
					searchWord: data.searchWord,
					page: data.page,
					limit: data.pageSize,
					exoType: data.checkType, //费用类型
					exoOdrId: "", //运单号
					exoAdvanceType: data.AdvanceType, //0公司固定点费用；1垫付
					exoChkStatus: data.ChkStatus, //审核状态：0未审核；1通过；2不通过
					exoEaStatus: data.EaStatus, //报销状态：0未报销；1已报销
					startTime: data.dayArr && data.dayArr.length > 0 ? data.dayArr[0] : "",
					endTime: data.dayArr && data.dayArr.length > 0 ? data.dayArr[1] : "",
				};

				const r = await proxy.$http.get(apiObj.expensesOrderSum, params);
				console.log(r);
				if (r.respCode == "0000") {
					data.exoSumCount = r.odrCount;
					data.exoSumMoney = r.sumMoney;
					data.exoWaitPayMoney = r.eaMoney;
					data.exoWaitChkMoney = r.chkMoney;
				}

			};

			//获取审批状态数量
			const getOrderListCount = async () => {
				console.log(data.dayArr);
				let params = {
					startTime: data.dayArr && data.dayArr.length > 0 ? data.dayArr[0] : "",
					endTime: data.dayArr && data.dayArr.length > 0 ? data.dayArr[1] : "",
				};
				const r = await proxy.$http.get(apiObj.expensesOrderCount, params);
				console.log(r);
				if (r.respCode == "0000") {
					data.orderNum = r;
					console.log(data.orderNum);
				}

			};

			const get24hoursRangeTime = () => {
				//当前设定的日期时间
				let rangeArr = []; //定义一个装时间的数组
				let d = new Date();
				let year1, month1, day1, hour1, minutes1, seconds1;
				year1 = d.getFullYear();
				month1 = d.getMonth() + 1;
				day1 = d.getDate();
				hour1 = d.getHours();
				minutes1 = d.getMinutes();
				seconds1 = d.getSeconds();
				month1 = month1 < 10 ? '0' + month1 : month1;
				day1 = day1 < 10 ? '0' + day1 : day1;
				hour1 = hour1 < 10 ? '0' + hour1 : hour1;
				minutes1 = minutes1 < 10 ? '0' + minutes1 : minutes1;
				seconds1 = seconds1 < 10 ? '0' + seconds1 : seconds1;
				let value1 = year1 + '-' + month1 + '-' + day1 + ' ' + hour1 + ':' + minutes1 + ':' + seconds1;
				rangeArr.push(value1);
				//前一天设定的日期时间
				let year2, month2, day2, hour2, minutes2, seconds2;
				//getTime() 返回距 1970 年 1 月 1 日之间的毫秒数,setTime设置 Date 对象的日期和时间值
				d.setTime(d.getTime() - 30 * 24 * 60 * 60 * 1000); //减去一天的毫秒时间，就是前一天的了
				year2 = d.getFullYear();
				month2 = d.getMonth() + 1;
				day2 = d.getDate();
				hour2 = d.getHours();
				minutes2 = d.getMinutes();
				seconds2 = d.getSeconds();
				month2 = month2 < 10 ? '0' + month2 : month2;
				day2 = day2 < 10 ? '0' + day2 : day2;
				hour2 = hour2 < 10 ? '0' + hour2 : hour2;
				minutes2 = minutes2 < 10 ? '0' + minutes2 : minutes2;
				seconds2 = seconds2 < 10 ? '0' + seconds2 : seconds2;
				let value2 = year2 + '-' + month2 + '-' + day2 + ' ' + hour2 + ':' + minutes2 + ':' + seconds2;
				rangeArr.unshift(value2);
				return rangeArr;
			};

			// 添加 根目录
			const add = () => {
				data.isAdd = true;
				nextTick(() => {
					proxy.$refs.addRef.init();
				});
			};

			// 菜单编辑
			const edit = (id) => {
				data.isEdit = true;
				nextTick(() => {
					proxy.$refs.editRef.init(id);
				});
			};
			// 审批费用详情
			const detail = (id) => {
				data.isDetail = true;
				nextTick(() => {
					proxy.$refs.detailRef.init(id);
				});
			};
			//费用删除
			const del = (id) => {
				proxy
					.$confirm("您确定删除选中的费用吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							exoId: id,
						};
						const r = await proxy.$http.postFormData(apiObj.expensesOrderRemove, params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};

			//菜单撤销
			const cancel = (lorId) => {
				proxy
					.$confirm("您确定撤销选中的运单吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							lorId: lorId,
						};
						const r = await proxy.$http.postFormData(apiObj.ordCancel, params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};

			//报销
			const tobaoxiao = (exoId) => {
				proxy
					.$confirm("您确定报销选中的费用吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							exoId: exoId,
						};
						const r = await proxy.$http.postFormData(apiObj.expensesOrderWriteOff, params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};

			//切换状态运单
			const changeNav = (val) => {

				if (val == '') {
					data.ChkStatus = "";
					data.EaStatus = "";
					data.AdvanceType = "";
				} else if (val == '0') {
					//待审批
					data.ChkStatus = "0";
					data.EaStatus = "";
					data.AdvanceType = "";
				} else if (val == '1') {
					//等付款
					data.ChkStatus = "1";
					data.EaStatus = "0";
					data.AdvanceType = "1";
				} else if (val == '2') {
					//已通过
					data.ChkStatus = "1";
					data.EaStatus = "";
					data.AdvanceType = "";
				} else if (val == '3') {
					//已驳回
					data.ChkStatus = "2";
					data.EaStatus = "";
					data.AdvanceType = "";
				} else if (val == '4') {
					//已付款
					data.ChkStatus = "";
					data.EaStatus = "1";
					data.AdvanceType = "1";
				}

				data.changeLorstatus = val;

				// this.currentPage = 1;
				// this.tableData = [];
				getData();
			};

			const handleAudits = (exoId) => {
				data.isAudit = true;
				data.auditsexoId = exoId;
				data.auditsRemark = "";
			};

			//审核
			const Auditssubmit = async (status) => {
				if (status == 1 && data.auditsRemark == "") {
					proxy.$message.error("请输入审核原因");
					return;
				}

				let params = {
					exoId: data.auditsexoId,
					operate: status, //操作类型：0通过，1不通过
					remark: data.auditsRemark
				};

				const r = await proxy.$http.postFormData(apiObj.expensesOrderExamine, params);
				if (r.respCode == 0 || r.respCode == "0000") {
					proxy.$message.success(r.msg || r.respMsg);
					data.isAudit = false;
					getData();
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}

			};

			const navClick = (index) => {
				data.tabindex = index;
				if (index == 1) {
					data.translateXValue = 0;
				} else if (index == 2) {
					data.translateXValue = 130;
				} else if (index == 3) {
					data.translateXValue = 260;
				} else if (index == 4) {
					data.translateXValue = 390;
				} else if (index == 5) {
					data.translateXValue = 520;
				}

			};

			const leftClick = (index) => {
				data.Leftindex = index;
			};

			return {
				...toRefs(data),
				getData,
				add,
				edit,
				detail,
				del,
				cancel,
				changeNav,
				tobaoxiao,
				handleAudits,
				Auditssubmit,
				navClick,
				leftClick
			};
		},
	});
</script>

<style scoped>
	.page_warp {
		width: 100%;
		height: 100%;
	}

	.nav_warp {
		width: 100%;
		height: 60px;
		background: #ffffff;
		border-bottom: 1px solid #eeeeee;
		display: flex;
		align-items: center;
	}

	.nav_item {
		position: relative;
		height: 78px;
		padding: 0 20px;
		margin-left: 50px;
		cursor: pointer;
	}

	.nav_item span {
		font-size: 15px;
		color: #666666;
		line-height: 78px;
	}

	.nav_item_ac span {
		color: #293787 !important;
	}

	.nav_item_line {
		position: absolute;
		width: 90%;
		left: 5%;
		height: 3px;
		background: #293787;
		bottom: 5px;
	}

	.orderNav {
		/* width: 100%; */
		background: #ffffff;
		border-radius: 10px;
		height: 60px;
		font-size: 16px;
		color: #333;
		/* margin-bottom: 20px; */
	}

	.orderNav p {
		margin: 0 15px;
		position: relative;
	}

	.orderNav p.ac {
		color: #e36a19;
		cursor: pointer;
	}

	.orderNav p span {
		display: block;
		width: 20px;
		height: 20px;
		background: #ff0000;
		border-radius: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #fff;
		position: absolute;
		top: -10px;
		right: -10px;
	}

	.orderPicker {
		margin-top: 10px;
		height: 50px;
	}

	.orderPicker .el-range__icon {
		margin-right: 10px !important;
	}

	.cursor {
		cursor: pointer;
	}

	.btn-outline1 {
		background: #ff6600 !important;
	}

	.btn-outline2 {
		background: #2eb779 !important;
	}

	.btn_warp {
		width: 100%;
		height: 80px;
		display: flex;
		justify-content: center;
		align-content: center;
	}

	.btn_warp>div {
		width: 90px;
		height: 36px;
		border-radius: 6px;
		font-size: 14px;
		color: #ffffff;
		cursor: pointer;
		text-align: center;
		line-height: 36px;
		margin-left: 20px;
	}

	.mar-bot-20 {
		margin-bottom: 20px !important;
	}

	.cell-style {
		white-space: nowrap;
		/* 防止内容换行 */
		overflow: hidden;
		/* 超出部分隐藏 */
		text-overflow: ellipsis;
		/* 显示省略符号来代表被修剪的文本 */
	}

	.message {
		flex: 1;
		padding: 24px;
		background: #f0f1f5;
		height: 92%;
	}

	.message .messageCen {
		height: 100%;
		background: #fff;
		box-shadow: 0 -2px 20px 0 rgba(0, 0, 0, .11);
		font-size: 14px;
		display: flex;
		flex-direction: column
	}

	.message .messageT {
		font-size: 20px;
		font-weight: 500;
		color: rgba(0, 0, 0, .85);
		line-height: 28px;
		padding-top: 31px;
		padding-left: 40px;
		position: relative
	}

	.message .messageTRight {
		position: absolute;
		right: 90px;
		bottom: 0
	}

	.message .messageTRight>span {
		font-size: 14px;
		color: rgba(0, 0, 0, .65);
		margin-right: 5px
	}

	.message .messageDiv {
		flex: 1;
		display: flex;
		flex-direction: column
	}

	.message .messageDiv .messageTop {
		padding-top: 36px;
		position: relative
	}

	.message .messageDiv .messageTop .el-tabs__header {
		margin: 0
	}

	.message .messageDiv .messageTop .el-tabs__nav-wrap.is-top {
		padding-left: 40px
	}

	.message .messageDiv .messageTop .el-tabs__nav-wrap.is-top .el-tabs__item {
		font-size: 14px;
		padding: 0 28px
	}

	.message .messageDiv .messageTop .el-tabs__nav-wrap.is-top .el-tabs__item.is-top:nth-child(2) {
		padding-left: 0
	}

	.message .messageDiv .messageTop .el-tabs__nav-wrap.is-top .el-tabs__item.is-top:last-child {
		padding-right: 0
	}

	.message .messageDiv .messageTop .el-tabs__nav-wrap.is-top:after {
		height: 1px;
		background-color: #e9e9e9
	}

	.message .messageDiv .messageTop .readBtn {
		position: absolute;
		right: 90px;
		bottom: 4px;
		font-size: 14px;
		color: rgba(0, 0, 0, .65)
	}

	.message .messageDiv .messageBottom {
		display: flex;
		flex: 1;
		position: relative
	}

	.message .messageDiv .messageBottom .messageBottomLeft {
		flex: 0 0 175px;
		border-right: 1px solid hsla(0, 0%, 59.2%, .21);
		padding: 12px 0;
		max-height: 100%;
		position: relative;
		overflow-y: auto;
		min-height: 380px
	}

	.message .messageDiv .messageBottom .messageBottomLeft>div {
		position: absolute
	}

	.message .messageDiv .messageBottom .messageBottomLeft .messageLeftList {
		height: 36px;
		margin: 6px 0;
		padding-left: 43px;
		font-weight: 400;
		color: rgba(0, 0, 0, .65);
		line-height: 36px;
		cursor: pointer
	}

	.message .messageDiv .messageBottom .messageBottomLeft .messageLeftList.this {
		background: rgba(24, 144, 255, .05);
		box-shadow: inset 2px 0 0 0 #0091ff;
		color: #1890ff
	}

	.message .messageDiv .messageBottom .messageBottomList {
		margin: 14px 40px 60px 30px;
		flex: 1;
		position: relative
	}

	.message .messageDiv .messageBottom .messageBottomList .messageBottomListDiv {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		overflow-y: auto
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists {
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 16px 0;
		border-bottom: 1px solid #e9e9e9
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists:hover {
		background: #fafafa
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists .tableListsImg {
		width: 48px;
		height: 48px;
		margin-left: 4px;
		margin-right: 24px
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists .tableListsCen {
		flex: 1
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists .tableListsCen .tableListsCenT {
		font-size: 14px;
		font-weight: 500;
		color: rgba(0, 0, 0, .65);
		line-height: 22px
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists .tableListsCen .tableListsCenT.title {
		font-weight: 700;
		font-size: 16px;
		color: #303133;
		margin: 0;
		margin-bottom: 20px
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists .tableListsCen .tableListsCenB {
		font-size: 14px;
		font-weight: 400;
		color: rgba(0, 0, 0, .45);
		line-height: 22px
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists .tableListsTime {
		margin-left: 20px;
		flex: 0 0 150px;
		font-size: 14px;
		color: rgba(0, 0, 0, .45);
		line-height: 22px
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists .tableListsState {
		flex: 0 0 140px
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists .tableListsState .tableListsStates {
		font-size: 14px;
		font-weight: 400;
		line-height: 22px;
		position: relative;
		padding-left: 21px;
		margin-left: 40px;
		cursor: auto
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists .tableListsState .tableListsStates:after {
		content: "";
		position: absolute;
		width: 8px;
		height: 8px;
		left: 8px;
		top: 50%;
		transform: translateY(-50%);
		border-radius: 50%
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists .tableListsState .tableListsStates:hover .ydClick {
		display: flex
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists .tableListsState .tableListsStates .ydClick {
		flex-direction: column;
		position: absolute;
		top: 28px;
		left: 50px;
		transform: translateX(-69%);
		width: 80px;
		background: rgba(0, 0, 0, .75);
		box-shadow: 0 9px 28px 8px rgba(0, 0, 0, .05), 0 6px 16px 0 rgba(0, 0, 0, .08), 0 3px 6px -4px rgba(0, 0, 0, .12);
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #fff;
		line-height: 22px;
		display: none;
		align-content: center;
		justify-content: center;
		align-items: center;
		padding: 8px 0;
		z-index: 99
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists .tableListsState .tableListsStates .ydClick:after {
		content: "";
		position: absolute;
		top: -12px;
		left: 50%;
		transform: translateX(-50%);
		width: 0;
		height: 0;
		border: 6px solid transparent;
		border-bottom-color: rgba(0, 0, 0, .75)
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists .tableListsState .tableListsStates .ydClick:before {
		content: "";
		width: 100%;
		position: absolute;
		left: 0;
		top: -30px;
		height: 30px
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists .tableListsState .tableListsStates .ydClick span {
		cursor: pointer
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists .tableListsState .tableListsStates .ydClick span:not(:last-child) {
		margin-bottom: 4px
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists .tableListsState .tableListsStates .ydClick span:hover {
		color: #fff
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists .tableListsState .tableListsState1 {
		color: rgba(0, 0, 0, .36)
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists .tableListsState .tableListsState1:after {
		background: #d8d8d8
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists .tableListsState .tableListsState0 {
		color: #ef4040
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists .tableListsState .tableListsState0>i {
		color: #a4a4a4
	}

	.message .messageDiv .messageBottom .messageBottomList .tableLists .tableListsState .tableListsState0:after {
		background: #ff2234
	}

	.emptyDiv {
		height: 100%;
		width: 100%;
		display: flex;
		flex-direction: column;
		position: relative;
		justify-content: center;
		align-items: center;
		padding: 30px 0;
		box-sizing: border-box
	}

	.emptyDiv img {
		height: 113px;
		width: 273px
	}

	.emptyDiv p {
		font-size: 14px;
		color: #666;
		margin-top: 17px;
		line-height: 1
	}
</style>